import { useCallback } from "react";
import {
	checklistAnswerPresigned,
	uploadFileToPresignedUrl,
} from "../services";
import type { AnnotatedFile } from "../types";

type UploadChecklistImageParams = {
	file: AnnotatedFile;
	questionAnswerId: number;
	answerId: number;
	answerToken: string;
};

export function useChecklistImageUpload() {
	const uploadImage = useCallback(
		async ({
			file,
			questionAnswerId,
			answerId,
			answerToken,
		}: UploadChecklistImageParams): Promise<{ fileKey: string }> => {
			if (!(file.name && file.type)) {
				throw new Error("Arquivo inválido.");
			}

			const response = await checklistAnswerPresigned({
				answerId,
				answerToken,
				files: [
					{
						fileName: file.name,
						contentType: file.type,
						questionAnswerId,
					},
				],
			});

			const presignedUrl = response.urls[0];
			if (!presignedUrl) {
				throw new Error("URL de upload não disponível.");
			}

			await uploadFileToPresignedUrl(
				presignedUrl.uploadUrl,
				file as File,
				presignedUrl.contentType
			);

			return { fileKey: presignedUrl.filePath };
		},
		[]
	);

	return { uploadImage };
}
